import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

const STORAGE_KEY = "cw_cookie_pref_v1";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (!saved) setVisible(true);
  }, []);

  const accept = (v) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ choice: v, at: new Date().toISOString() }));
    window.dispatchEvent(new CustomEvent("cw:cookie-consent", { detail: { choice: v } }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 z-50 max-w-md bg-white border border-brand-line rounded-2xl shadow-soft-lg p-5"
    >
      <div className="flex items-start justify-between gap-4">
        <div>
          <div className="eyebrow">Cookies</div>
          <h3 className="mt-1 font-display text-lg text-brand-ink leading-tight">A gentle note on cookies</h3>
        </div>
        <button onClick={() => accept("dismissed")} data-testid="cookie-close" className="w-8 h-8 grid place-items-center rounded-full text-brand-stone hover:bg-brand-pinkLight" aria-label="Dismiss">
          <X className="w-4 h-4" />
        </button>
      </div>
      <p className="mt-3 text-sm text-brand-stone font-ui leading-relaxed">
        We use strictly necessary cookies to make our site work — like remembering your quote cart. With your consent we may also use functional and analytics cookies. Read our <Link to="/legal/cookie-policy" className="text-brand-red hover:underline">Cookie Policy</Link>.
      </p>
      <div className="mt-4 flex flex-wrap gap-2">
        <button
          onClick={() => accept("accepted")}
          data-testid="cookie-accept"
          className="inline-flex items-center h-10 px-5 rounded-full bg-brand-red text-white text-xs font-ui font-semibold hover:bg-brand-redDark transition"
        >
          Accept all
        </button>
        <button
          onClick={() => accept("essential")}
          data-testid="cookie-essential"
          className="inline-flex items-center h-10 px-5 rounded-full border border-brand-ink text-brand-ink text-xs font-ui font-semibold hover:bg-brand-ink hover:text-white transition"
        >
          Essential only
        </button>
      </div>
    </div>
  );
}
